import './assets/PageHero.css';const o = "_hero_4s6yo_1", e = {
  hero: o,
  "background-image": "_background-image_4s6yo_11",
  "mobile-background-image": "_mobile-background-image_4s6yo_12"
};
export {
  e as s
};
